import { FEATURE_CODES, hasAllFeatures, hasFeature } from './features.js';

export const DRIVER_ADMIN_ROLES = Object.freeze(['dispatcher', 'economist', 'admin']);

export const getDriverAdministrationCapabilities = (role, features) => {
  const normalizedRole = String(role || '').trim().toLowerCase();
  const supportedRole = DRIVER_ADMIN_ROLES.includes(normalizedRole);
  const workforceEnabled = hasFeature(features, FEATURE_CODES.WORKFORCE_MANAGEMENT);
  const profitabilityEnabled = hasFeature(features, FEATURE_CODES.PROFITABILITY);
  const economistRequirementsMet = normalizedRole !== 'economist' || profitabilityEnabled;

  return {
    canManageProfile: supportedRole && workforceEnabled && economistRequirementsMet,
    canManageDocuments: supportedRole && workforceEnabled && economistRequirementsMet,
    canManageAccount: supportedRole && workforceEnabled && economistRequirementsMet,
    canManageFinancials: supportedRole && hasAllFeatures(
      features,
      FEATURE_CODES.WORKFORCE_MANAGEMENT,
      FEATURE_CODES.PROFITABILITY,
    ),
  };
};

export const isDriverActive = (driver) => {
  const value = driver?.is_active ?? driver?.user?.is_active ?? driver?.driver?.is_active;
  return value !== false;
};
